// extracted by mini-css-extract-plugin
module.exports = {"prizeTable":"_64ad66b"};